import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Form, Input} from 'antd'
import {UserOutlined} from '@ant-design/icons'
import Button from 'components/shared/Button'

function LoginForm({onSubmit}) {
  const [form] = Form.useForm()
  const [, forceUpdate] = useState()

  useEffect(() => {
    forceUpdate({})
  }, [])

  return (
    <Form form={form} onFinish={onSubmit} className="login-form">
      <Form.Item
        name="email"
        rules={[{required: true, message: 'E-post er påkrevd'}]}
      >
        <Input prefix={<UserOutlined />} placeholder="E-post" />
      </Form.Item>

      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            disabled={
              !form.isFieldsTouched(true) ||
              form.getFieldsError().filter(({errors}) => errors.length).length
            }
          >
            Motta engangskode
          </Button>
        )}
      </Form.Item>
    </Form>
  )
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default LoginForm
